import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      background: "#F4F5F8",
      direction: "rtl",
      overflow: "hidden",
    },

    contentWrapper: {
      flex: 1,
      minWidth: 0,
      height: "100%",
      display: "flex",
      flexDirection: "column",
      background: "#F4F5F8",
      overflow: "hidden",
    },

    topbarWrapper: {
      width: "100%",
      flexShrink: 0,
      position: "sticky",
      top: 0,
      zIndex: 100,
      background: "#FFFFFF",
    },

    scrollContent: {
      flex: 1,
      minHeight: 0,
      overflowY: "auto",
      overflowX: "hidden",
      padding: 0,
      boxSizing: "border-box",
      background: "#F4F5F8",
      scrollbarWidth: "none",
      msOverflowStyle: "none",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },

    pageContent: {
      display: "flex",
      flexDirection: "column",
      gap: 16,
      opacity: 1,
      marginTop: 10,
      marginLeft: 24,
      marginRight: 24,
      marginBottom: 24,
      boxSizing: "border-box",
    },

    detailsSection: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      width: "100%",
    },

    detailsCard: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      borderRadius: "4px",
      boxSizing: "border-box",
    },

    tabContent: {
      padding: "16px 0",
      boxSizing: "border-box",
      backgroundColor: "#F4F5F8",
      overflow: "visible",
    },

    tabLayout: {
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-start",
      gap: "16px",
      width: "100%",
      direction: "ltr",
    },

    diagramPane: {
      flexShrink: 0,
    },

    formPane: {
      flex: 1,
      minWidth: 0,
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      direction: "rtl",
      backgroundColor: theme.palette.background.paper,
      borderRadius: "4px",
      padding: "16px",
      boxSizing: "border-box",
    },

    formPaneQuotation: {
      backgroundColor: "transparent",
      padding: 0,
      gap: 0,
    },

    formPaneCentreOfGravity: {
      backgroundColor: "transparent",
      padding: 0,
      gap: 0,
    },

    formPaneLoadDistribution: {
      backgroundColor: "transparent",
      padding: 0,
      gap: 0,
    },
  })
);
